import React from "react";
import { Stack, Typography, styled } from "@mui/material";

import SnowMountainsImg from "assets/images/snow-mountains.png";
import { ReactComponent as AltiusIconGroup } from "./AltiusIconGroup.svg";

const NumberTitle = styled(Typography)(() => ({
  color: "#C09560",
  fontFamily: "Afacad",
  // fontFamily: "Roboto",
  fontSize: "40px",
  fontWeight: 700,
  lineHeight: 1
}));

const SubTitle = styled(Typography)(() => ({
  color: "white",
  fontFamily: "Afacad",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: 1
}));

export const SidePreview: React.FC = () => {
  return (
    <Stack
      sx={{
        p: "64px 53px",
        background: `linear-gradient(180deg, rgba(6, 1, 39, 0.90) 0%, rgba(6, 1, 39, 0.20) 100%), url(${SnowMountainsImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        flexGrow: 1,
        maxWidth: "30%",
        minWidth: "410px",
        gap: "50px"
      }}
    >
      <AltiusIconGroup />
      <Stack gap="15px">
        <Stack>
          <NumberTitle>+$85B</NumberTitle>
          <SubTitle>Managed through the platform</SubTitle>
        </Stack>
        <Stack>
          <NumberTitle>+4,500</NumberTitle>
          <SubTitle>Funds and Direct Investments</SubTitle>
        </Stack>
        <Stack>
          <NumberTitle>+250</NumberTitle>
          <SubTitle>Users, along with their guests and peers</SubTitle>
        </Stack>
      </Stack>
    </Stack>
  );
};
